import React from "react";
import ReactDOM from "react-dom";
import Language from "../../services/Language";
import InputPhone from "../../component/InputPhone/inputPhone";
import utils from "../../services/utils";
import InputCountry from "../../component/InputCountry/InputCountry";

class ComponentsWithCountryData {
  render() {
    // для получения региона пользователя
    utils.app_get(utils.getLocalizeUrl("/api/front/get-all-countries-with-base")).then((resp) => {
      this.renderInputPhone(resp)
      this.renderInputCountry(resp)
    });
  }

  renderInputCountry(resp) {
    const e = React.createElement;
    const elements = document.querySelectorAll('.initCountryInput');

    elements.forEach((element, key) => {
      ReactDOM.render(
        e(InputCountry, {
          countriesData: resp
        }),
        element
      );
    })
  }

  renderInputPhone(resp) {
    const e = React.createElement;
    const elements = document.querySelectorAll(".initPhoneInput");
    const lang = Language.getCurrentLanguage() || "en";

    elements.forEach((element) => {
      ReactDOM.render(
        e(InputPhone, {
          inputName: element.dataset.name || "phone",
          lang: lang,
          country: resp.type === "success" ? resp.data.isoCode : "ru",
        }),
        element
      );
    });
  }
}

export default ComponentsWithCountryData;
